export default __webpack_public_path__ + "static/media/Pot1.19dd5b3c.svg";